import { FunctionService } from './../function.service';
import { RouterService } from './../router.service';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { SendMessageService } from '../send-message.service';
import { DonateData, SendDonateData } from '../donate-data';
import { SettingService, YoutubeRestrictionData } from '../setting.service';
import { SettingData } from '../setting-data';
import { ControlData } from '../controll-screen/control-data';
import { CheckIdService } from '../check-id.service';
import { YoutubeApiService } from '../youtube-api.service';
import * as $ from "jquery";
// declare var jquery: any;
// declare let $: any;

@Component({
  selector: 'app-donate-screen',
  templateUrl: './donate-screen.component.html',
  styleUrls: ['./donate-screen.component.scss'],
})
export class DonateScreenComponent implements OnInit {
  player: YT.Player;
  id: string;
  name = '';
  donate: number;
  msg = '';
  yt = '';
  yid: string;
  time: number;
  endtime: number;
  startTime: number;
  settingData: SettingData;
  opeyUrl = 'https://payment.opay.tw/Broadcaster/Donate/';
  introduce: string;
  youtubeRestrictionData: YoutubeRestrictionData;
  private timer;
  private counter: Date;
  checkIDState = 0;
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private activateRouter: ActivatedRoute,
    private routerService: RouterService,
    private appComponent: AppComponent,
    private sendMessage: SendMessageService,
    private settingService: SettingService,
    private checkIDService: CheckIdService,
    private youtubeAPI: YoutubeApiService,
    private functionService: FunctionService,
  ) {
    this.matIconRegistry.addSvgIconInNamespace(
      'custom-svg',
      'angular',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/currency-twd.svg'
      )
    );
    checkIDService.checkStateChange.subscribe((value) => {
      if (value === 1) {
        this.checkIDState = 1;
      } else {
        alert('此ID不存在');
        this.routerService.GoToHomePage();
      }
    });
  }

  ngOnInit(): void {
    this.introduce = '歡迎抖內實況主';
    this.id = this.activateRouter.snapshot.paramMap.get('id');
    this.time = 0;
    this.startTime = 0;
    this.settingService.settingDataChange.subscribe((settingData) => {
      this.settingData = settingData;
      this.opeyUrl += this.settingData.opay_payment_hash;
      this.introduce = this.settingData.msg;
      // this.youtubeRestrictionData = this.settingService.getYoutubeRestriction(
      //   settingData.youtubeRestrictionLevel
      // );
    });
    this.appComponent.client.subscribe('check_id/' + this.id + '/res');
    this.appComponent.client.subscribe('account/' + this.id + '/res');
    const loginData = new ControlData(this.id, 'login');
    const message = JSON.stringify(loginData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'account/' + this.id + '/send'
    );
    this.sendMessage.sendMessage(
      this.appComponent.client,
      JSON.stringify({ id: this.id }),
      'check_id/send'
    );
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy() {
    this.timer.unsubscribe();
  }

  send(): void {
    this.checkAmount(this.donate);
  }

  checkAmount(amount: number) {
    if (amount < this.settingData.min_money) {
      alert('金額必須大於' + this.settingData.min_money + '元');
    // } else if (this.yt.length > 0) {
    //   this.youtubeAPI.getVideoStatistics(this.yid).subscribe((res) => {
    //     if (
    //       res.items.length > 0 &&
    //       res.items[0].statistics.viewCount >
    //         this.youtubeRestrictionData.viewCountRestriction &&
    //       res.items[0].statistics.likeCount /
    //         (res.items[0].statistics.likeCount +
    //           res.items[0].statistics.dislikeCount) >
    //         this.youtubeRestrictionData.goodRateRestriction
    //     ) {
    //       this.submit();
    //     } else {
    //       alert('此影片不符合規定');
    //       this.yt = '';
    //       this.yid = '';
    //     }
    //   });
    } else {
      this.submit();
    }
  }
  onkeyupYT(event: any) {
    [this.yt, this.startTime] = this.functionService.convertUrl(this.yt);
    this.yid = this.functionService.parserYTID(this.yt);
  }
  endTime() {
    this.endtime =
      this.settingData.basetime + this.startTime +  this.settingData.times * this.donate;
  }
  submit() {
    $('#formsend').submit();
    const donateData: SendDonateData = new SendDonateData(
      this.id,
      this.name,
      this.donate,
      this.yt,
      this.startTime,
      this.time,
      this.msg
    );
    const message = JSON.stringify(donateData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'predonate/' + this.id + '/send'
    );
  }
}
